namespace RioERP.Web.Enums {
    export enum SMSEvent {
        CACSCMAStudents = 1
    }
    Serenity.Decorators.registerEnumType(SMSEvent, 'RioERP.Web.Enums.SMSEvent');
}
